module.exports = __webpack_public_path__ + "static/fonts/AvenirLTStd-Heavy.b9f8585.otf";


//////////////////
// WEBPACK FOOTER
// ./src/css/AvenirLTStd-Heavy.otf
// module id = 8wb/
// module chunks = 1